import './App.css';
import ResponsiveNavbar from './components/ResponsiveNavbar';

function App() {

  return (
    <div className="App">
      <ResponsiveNavbar/>
    </div>
  );
}

export default App;
